import React, { PropsWithChildren, FC } from 'react';
import { Variants } from 'common';

import { TextCopyContext } from 'infrastructure/targets/web/contexts/TextCopyContext';
import TextCopy, { resolveDuckpinCopy } from 'infrastructure/targets/web/assets/text/text';
import { isGenericDuckpin } from 'infrastructure/targets/web/modules/bookingWizard/Steps/SessionLengthStep/helpers';

export const TextCopyContextProvider: FC<PropsWithChildren<object>> = ({ children }) => {
  const variant = (process.env.VITE_VARIANT || Variants.FIVEIRON) as Variants;
  const generic = isGenericDuckpin();
  const provider = {
    getTextCopy: (code: string) =>
      variant === Variants.DUCKPIN ? resolveDuckpinCopy(code, generic) : TextCopy[variant][code],
  };

  return <TextCopyContext.Provider value={provider}>{children}</TextCopyContext.Provider>;
};
